import api, { masonCtlKey } from "../api";
import MasonDocument from "lib/mason";
import { PageData } from "hooks/usePagedData";

// API path
const path = `notifications`;

/**
 * Get a list of notifications for the user
 */
const getAll = async (params?: { offset: number; limit: number }) => {
	const res = await api.request({
		url: `${path}${
			params ? `?limit=${params.limit}&offset=${params.offset}` : ``
		}`,
		method: "GET",
	});

	const data: { unread: number; pageData: PageData } = {
		unread: res.data.unread,
		pageData: {
			hasMore: false,
			results: res.data.matches,
		},
	};

	// TODO: add template to mason response in notifications service to remove this mess?
	if (MasonDocument.hasControl(res.data, masonCtlKey.notifications.page)) {
		const href = MasonDocument.getControl(
			res.data,
			masonCtlKey.notifications.page
		)?.href;

		if (href) {
			const limit = parseInt(
				href.substring(
					href.lastIndexOf("limit=") + 6,
					href.lastIndexOf("&")
				)
			);
			const offset = parseInt(
				href.slice(href.lastIndexOf("offset=") + 7)
			);
			data.pageData.hasMore = true;
			data.pageData.limit = limit;
			data.pageData.offset = offset;
		}
	}

	return data;
};

/**
 * Mark a notification as read
 *
 * @param id notification id
 */
const read = (id: string) => {
	return api.request({
		method: "PUT",
		url: `${path}/${id}`,
	});
};

/**
 * Get an unread notifications count
 */
const unreadCount = async () => {
	const res = await api.request({
		method: "GET",
		url: `${path}/unreadcount`,
		customOpts: {
			handleErrors: true,
		},
	});
	return res.data.data;
};

/**
 * Mark all notifications as read
 */
const markAllRead = () => {
	return api.request({
		method: "PUT",
		url: path,
	});
};

/**
 * Delete a notification
 *
 * @param id notification id
 */
const deleteOne = async (id: string) => {
	return api.request({
		method: "DELETE",
		url: `${path}/${id}`,
	});
};

const deleteAll = async () => {
	return api.request({
		method: "DELETE",
		url: `${path}/`,
	});
};

export default {
	read,
	unreadCount,
	markAllRead,
	deleteOne,
	getAll,
	deleteAll,
};
